import { useQuery } from "react-query"
import { request } from "../util/request"

const fetchBandPlaylists =
  (filterType: "created_by_band" | "includes_band", bandId: number | string, perPage: number) =>
  async () =>
    request({
      queryKey: [
        `bandPlaylists_${filterType}`,
        {
          path: "/api/v1/playlists",
          params: {
            "filters[type]": filterType,
            "filters[band_id]": bandId,
            per_page: perPage,
          },
        },
      ],
    })

export function useBandCreatedPlaylists(bandId: number | string, perPage = 50) {
  return useQuery(
    ["bandCreatedPlaylists", bandId, perPage],
    fetchBandPlaylists("created_by_band", bandId, perPage),
    { enabled: !!bandId },
  )
}

export function useBandFeaturedPlaylists(bandId: number | string, perPage = 50) {
  return useQuery(
    ["bandFeaturedPlaylists", bandId, perPage],
    fetchBandPlaylists("includes_band", bandId, perPage),
    { enabled: !!bandId },
  )
}
